export default {
  getPreferredDeliveryAddress: (state) => state.preferredDeliveryAddress,
};
